import { useState } from "react";
import { useAuth } from "../lib/auth";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";
import { Terminal } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1760813360432-9b5d79eb9679?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc3BhY2VzaGlwJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc3NTk4MDkyfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(id, pw); toast.success("Access granted"); nav("/dashboard"); }
    catch { toast.error("Authentication failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden px-4">
      <div className="crt-overlay" />
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${BG})`, filter: "grayscale(0.6) sepia(0.5) hue-rotate(-20deg)" }} />
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative z-10 w-full max-w-md p-8 sm:p-10 panel">
        <div className="flex items-center gap-2 amber amber-glow heading-mono text-2xl flicker mb-1">
          <Terminal size={24} strokeWidth={1.5} /> SPACEBOOK
        </div>
        <div className="mono text-[10px] text-[#4AF626] tracking-[0.25em] uppercase mb-8">
          // Weyland-Yutani Corp. Crew Authentication
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="label-term mb-2 block">Username / Email</label>
            <input data-testid="login-identifier" className="input-term" value={id} onChange={(e) => setId(e.target.value)} required autoFocus />
          </div>
          <div>
            <label className="label-term mb-2 block">Password</label>
            <input data-testid="login-password" type="password" className="input-term" value={pw} onChange={(e) => setPw(e.target.value)} required />
          </div>
          <button data-testid="login-submit" className="btn-amber w-full" disabled={loading}>
            {loading ? "Verifying..." : "> Authenticate"}
          </button>
        </form>
        <div className="mt-6 mono text-xs text-[#A0A0A0] text-center">
          New crew member? <Link to="/register" className="amber hover:underline" data-testid="nav-register">Register</Link>
        </div>
      </div>
      <Toaster theme="dark" />
    </div>
  );
}
